import { DynamicLinkedinRequestId, StaticLinkedinRequestId } from "waapi/types-utils/lib/LinkedinRequests/types.js";

export const SIMULATE_MOBILE_HEADER_KEY = "x-simulate-mobile";
export const CONVERSATION_LAST_EVENT_FROM_LINKEDIN = "LINKEDIN";
export const CONVERSATION_LAST_EVENT_NEED_TO_BE_POPULATED = "NEET_TO_BE_POPULATED";
export const REQUESTS_WITH_TOO_MANY_DATA: string[] = [
    DynamicLinkedinRequestId.GET_COMPANY_FEED_POSTS,
    StaticLinkedinRequestId.BASIC_REGULAR_SEARCH_COMPONENT_VERSION,
];
export enum ConnectRestrictionsTypes {
    UNDOCUMENTED = "UNDOCUMENTED_CONNECT_RESTRICTED",
    MOBILE = "MOBILE_CONNECT_RESTRICTED",
    DESKTOP = "DESKTOP_CONNECT_RESTRICTED",
    CONNECT_NOTE_RESTRICTED = "CONNECT_NOTE_RESTRICTED",
    WEEKLY_CONNECTIONS_LIMIT_REACHED = "WEEKLY_CONNECTIONS_LIMIT_REACHED",
}
export enum ConnectFailureReason {
    PROFILE_CANT_BE_ACCESSED = "PROFILE_CANT_BE_ACCESSED",
    REINVITE_THREE_WEEKS_DELAY = "REINVITE_THREE_WEEKS_DELAY",
    ACCOUNT_BLOCKED = "ACCOUNT_BLOCKED",
    INVALID_INVITATION_STATE = "INVALID_INVITATION_STATE",
}
export enum MessageRestrictionsTypes {
    REQUEST = "MESSAGE_REQUEST_RESTRICTED",
}
export type RestrictionsTypes = ConnectRestrictionsTypes | MessageRestrictionsTypes;
export enum ENTITY_TYPES {
    ACTION_INVITATION_PENDING = "com.linkedin.voyager.identity.profile.actions.InvitationPending",
    ACTION_RESPONSE = "com.linkedin.restli.common.ActionResponse",
    ACTOR_COMPONENT = "com.linkedin.voyager.dash.feed.component.actor.ActorComponent",
    ACTOR_MINI_PROFILE = "com.linkedin.voyager.identity.me.ActorMiniProfile",
    CARD = "com.linkedin.voyager.identity.me.Card",
    COLLECTION_METADATA = "com.linkedin.restli.common.CollectionMetadata",
    COLLECTION_RESPONSE = "com.linkedin.restli.common.CollectionResponse",
    COMMENTARY_COMPONENT = "com.linkedin.voyager.dash.feed.component.commentary.CommentaryComponent",
    DASH_COMMENTER = "com.linkedin.voyager.dash.social.Commenter",
    COMMON_GEO = "com.linkedin.voyager.common.Geo",
    COMMON_VECTOR_IMAGE = "com.linkedin.common.VectorImage",
    COMMON_VECTOR_ARTIFACT = "com.linkedin.common.VectorArtifact",
    COMPANY = "com.linkedin.voyager.organization.Company",
    COMPOSE_COMPOSE_OPTION = "com.linkedin.voyager.dash.messaging.compose.ComposeOption",
    CONNECTIONS_SUMMARY = "com.linkedin.voyager.relationships.shared.connection.ConnectionsSummary",
    CREATOR_ANALYTICS_PREVIEW = "com.linkedin.voyager.dash.creatorexperience.dashboard.CreatorAnalyticsPreview",
    CREATOR_DASHBOARD = "com.linkedin.voyager.dash.creatorexperience.dashboard.CreatorDashboard",
    CREATOR_DASHBOARD_ANALYTICS_SECTION = "com.linkedin.voyager.dash.creatorexperience.dashboard.CreatorDashboardAnalyticsSection",
    DASH_COMPANY = "com.linkedin.voyager.dash.organization.Company",
    DASH_GROUP = "com.linkedin.voyager.dash.groups.Group",
    DASH_GROUP_MEMBERSHIP = "com.linkedin.voyager.dash.groups.GroupMembership",
    DASH_PROFESSIONAL_EVENT = "com.linkedin.voyager.dash.events.ProfessionalEvent",
    DASH_EDGE_INSIGHTS_ANALYTICS_CARD = "com.linkedin.voyager.dash.edgeinsightsanalytics.Card",
    DATE = "com.linkedin.common.Date",
    DATE_RANGE = "com.linkedin.common.DateRange",
    ENTITY_RESULT_VIEW_MODEL = "com.linkedin.voyager.dash.search.EntityResultViewModel",
    EXTERNAL_MEDIA = "com.linkedin.messenger.ExternalMedia",
    EXTERNAL_PROXY_IMAGE = "com.linkedin.messenger.ExternalProxyImage",
    FEATURE_ACTION = "com.linkedin.voyager.feed.render.FeatureAction",
    FEED_COMMENT = "com.linkedin.voyager.feed.Comment",
    DASH_FEED_COMMENT = "com.linkedin.voyager.dash.social.Comment",
    FEED_FOLLOWING_STATE = "com.linkedin.voyager.dash.feed.FollowingState",
    FEED_RENDER_UPDATE_V2 = "com.linkedin.voyager.feed.render.UpdateV2",
    FEED_DASH_UPDATE = "com.linkedin.voyager.dash.feed.Update",
    FEED_DASH_UPDATE_METADATA = "com.linkedin.voyager.dash.feed.metadata.UpdateMetadata",
    FOLLOWING_INFO = "com.linkedin.voyager.common.FollowingInfo",
    FULL_PROFILE_VIEWER = "com.linkedin.voyager.identity.me.FullProfileViewer",
    GENERIC_HIGHLIGHT_V2 = "com.linkedin.voyager.identity.shared.GenericHighlightV2",
    PAGED_LIST_COMPONENT = "com.linkedin.voyager.dash.identity.profile.tetris.PagedListComponent",
    GEO = "com.linkedin.voyager.dash.common.Geo",
    GROUP = "com.linkedin.voyager.groups.Group",
    GROUP_MEMBER = "com.linkedin.voyager.groups.GroupMember",
    GROUP_MEMBERSHIP = "com.linkedin.voyager.groups.GroupMembership",
    HIGHLIGHT = "com.linkedin.voyager.identity.shared.Highlight",
    HIGHLIGHT_DETAILS = "com.linkedin.voyager.identity.shared.HighlightDetails",
    IMAGE_VIEW_MODEL = "com.linkedin.voyager.dash.common.image.ImageViewModel",
    INVITATION = "com.linkedin.voyager.relationships.invitation.Invitation",
    INVITATION_DASH = "com.linkedin.voyager.dash.relationships.invitation.Invitation",
    INVITATION_PENDING = "com.linkedin.voyager.relationships.invitation.SentInvitationViewV2",
    INVITATIONS_SUMMARY = "com.linkedin.voyager.relationships.invitation.InvitationsSummary",
    LIKE = "com.linkedin.voyager.feed.Like",
    ME_PANEL = "com.linkedin.voyager.identity.me.Panel",
    MEDIA_PROXY_IMAGE = "com.linkedin.voyager.common.MediaProxyImage",
    MEDIA_UPLOAD_METADATA = "com.linkedin.mediauploader.MediaUploadMetadata",
    MEMBER_ACTOR = "com.linkedin.voyager.feed.MemberActor",
    MEMBER_DISTANCE = "com.linkedin.voyager.common.MemberDistance",
    MEMBER_RELATIONSHIP = "com.linkedin.voyager.dash.relationships.MemberRelationship",
    MEMBER_RELATIONSHIP_WRAPPER = "com.linkedin.voyager.dash.relationships.MemberRelationshipWrapper",
    FOLLOW_RELATION_SHIP = "com.linkedin.voyager.dash.relationships.FollowRelationship",
    DIRECTIONAL_ENTITY_RELATIONSHIP = "com.linkedin.voyager.dash.relationships.DirectionalEntityRelationship",
    MESSAGE_EVENT = "com.linkedin.voyager.messaging.event.MessageEvent",
    MESSAGE_IN_MAIL = "com.linkedin.voyager.messaging.event.message.InmailContent",
    MESSAGING_CONVERSATION = "com.linkedin.voyager.messaging.Conversation",
    MESSAGING_EVENT = "com.linkedin.voyager.messaging.Event",
    MINI_COMPANY = "com.linkedin.voyager.entities.shared.MiniCompany",
    MINI_PROFILE = "com.linkedin.voyager.identity.shared.MiniProfile",
    MINI_PROFILE_SETTINGS = "com.linkedin.settingsapi.MiniProfile",
    OPEN_TO_CARD = "com.linkedin.voyager.dash.identity.profile.opento.OpenToCard",
    OPEN_TO_ENROLLED_CARD = "com.linkedin.voyager.dash.identity.profile.opento.OpenToEnrolledCard",
    PARTICIPANT_RECEIPTS = "com.linkedin.voyager.messaging.ParticipantReceipts",
    PHOTO_FILTER_PICTURE = "com.linkedin.voyager.dash.identity.profile.PhotoFilterPicture",
    PROFESSIONAL_EVENT = "com.linkedin.voyager.growth.events.ProfessionalEvent",
    PROFESSIONAL_EVENT_VIEWER_STATE = "com.linkedin.voyager.dash.scheduledcontent.ScheduledContentViewerState",
    PROFILE_ACTION = "com.linkedin.voyager.dash.identity.profile.actions.ProfileActions",
    PROFILE_POSITION = "com.linkedin.voyager.dash.identity.profile.Position",
    PROFILE_PROFILE = "com.linkedin.voyager.dash.identity.profile.Profile",
    PROFILE_VIEWS_PANEL = "com.linkedin.voyager.identity.me.ProfileViewsByTimePanel",
    REACTION = "com.linkedin.voyager.feed.social.Reaction",
    RELATIONSHIP_CONNECTION = "com.linkedin.voyager.dash.relationships.Connection",
    RELATIONSHIP_ACTION_DATA = "com.linkedin.voyager.dash.common.relationships.RelationshipActionData",
    RELATIONSHIP_NO_CONNECTION = "com.linkedin.voyager.dash.relationships.NoConnection",
    RELATIONSHIP_NO_INVITATION = "com.linkedin.voyager.dash.relationships.invitation.NoInvitation",
    SALES_CAP_IDENTITY = "com.linkedin.sales.authentication.SalesCapIdentity",
    SALES_EP_IDENTITY = "com.linkedin.sales.authentication.SalesEpIdentity",
    SAVE_ACTION = "com.linkedin.voyager.feed.render.SaveAction",
    SEARCH_CLUSTER_COLLECTION_METADATA = "com.linkedin.voyager.dash.search.SearchClusterCollectionMetadata",
    SEARCH_CLUSTER_VIEW_MODEL = "com.linkedin.voyager.dash.search.SearchClusterViewModel",
    SEARCH_ENTITY_ACTION = "com.linkedin.voyager.dash.search.EntityAction",
    SEARCH_ITEM = "com.linkedin.voyager.dash.search.SearchItem",
    SEARCH_LAZY_LOADED_ACTIONS = "com.linkedin.voyager.dash.search.LazyLoadedActions",
    SEEN_RECEIPT = "com.linkedin.voyager.messaging.SeenReceipt",
    SOCIAL_ACTIVITY_COUNTS = "com.linkedin.voyager.feed.shared.SocialActivityCounts",
    SOCIAL_DETAIL = "com.linkedin.voyager.feed.SocialDetail",
    DASH_SOCIAL_DETAIL = "com.linkedin.voyager.dash.social.SocialDetail",
    SOCIAL_PERMISSIONS = "com.linkedin.voyager.feed.social.SocialPermissions",
    TETRIS_CARD = "com.linkedin.voyager.dash.identity.profile.tetris.Card",
    TETRIS_COMPONENT = "com.linkedin.voyager.dash.identity.profile.tetris.Component",
    TEXT_VIEW_MODEL = "com.linkedin.voyager.dash.common.text.TextViewModel",
    TEXT_VIEW_MODEL_V2 = "com.linkedin.voyager.dash.deco.common.text.TextViewModelV2",
    THIRD_PARTY_MEDIA = "com.linkedin.voyager.messaging.shared.ThirdPartyMedia",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    UPDATE_V2 = "com.linkedin.voyager.feed.render.UpdateV2",
    VIEWS_SUMMARY = "urn:li:wvmp:summary",
    WVMP_CARD = "com.linkedin.voyager.identity.me.wvmpOverview.WvmpCard",
    WVMP_INSIGHT_CARD = "com.linkedin.voyager.identity.me.wvmpOverview.WvmpInsightCard",
    WVMP_PROFILE_VIEW_CARD = "com.linkedin.voyager.identity.me.WvmpProfileViewCard",
    WVMP_SUMMARY_INSIGHT_CARD = "com.linkedin.voyager.identity.me.wvmpOverview.WvmpSummaryInsightCard",
    WVMP_VIEWERS_CARD = "com.linkedin.voyager.identity.me.wvmpOverview.WvmpViewersCard",
    CUSTOM_INVITE_COMPOSE_VIEW = "com.linkedin.voyager.dash.relationships.invitation.CustomInviteComposeView",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    DASH_FEED_FOLLOWING_STATE = "com.linkedin.voyager.dash.feed.FollowingState",
    INDUSTRY_V2 = "com.linkedin.voyager.dash.identity.profile.IndustryV2",
    INDUSTRY = "com.linkedin.voyager.dash.identity.profile.Industry",
    SETTING_SNEAK_PEEK = "com.linkedin.settingsapi.SettingSneakPeek",
    SETTING = "com.linkedin.settingsapi.Setting",
}

export enum COMPONENT_ENTITY_TYPES {
    NAVIGATE_SECTION = "proto.sdui.actions.core.Navigate",
    SERVER_REQUEST_SECTION = "proto.sdui.actions.core.ServerRequest",
}

export const ALL_ENTITY_TYPES = Object.values(ENTITY_TYPES);
export const URN_PATTERNS = {
    INVITATION_VIEW: "^urn:li:fs_relInvitationView:[0-9]+$",
    INVITATION: "^urn:li:fs_relInvitation:[0-9]+$",
    MINI_PROFILE: "^urn:li:fs_miniProfile:.+$",
    COMPANY: "^urn:li:fs_normalized_company:[0-9]+$",
    CONVERSATION: "^urn:li:fs_conversation:(.*)",
    CONVERSATION_V2: "^urn:li:msg_conversation:(.*)",
    OBJECT_URN_MEMBER: "^urn:li:member:[0-9]+$",
} as const;
export const EXACT_URN = {
    WVMP_VIEWERS_CARD: "urn:li:fs_wvmpCard:wvmpViewersCard",
    SUMMARY: "urn:li:wvmp:summary",
};
export const HIGHLIGHTS_CONTROL_NAME = {
    SHARED_GROUPS: "highlights_shared_groups",
    SHARED_EVENT: "highlights_shared_events",
};
export enum MEDIA_UPLOAD_TYPES {
    MESSAGING_FILE_ATTACHMENT = "MESSAGING_FILE_ATTACHMENT",
    MESSAGING_PHOTO_ATTACHMENT = "MESSAGING_PHOTO_ATTACHMENT",
    MESSAGING_VIDEO_ATTACHMENT = "MESSAGING_VIDEO_ATTACHMENT",
    VOICE_MESSAGE = "VOICE_MESSAGE",
}
export enum FRAME_TYPE {
    OPEN_TO_WORK = "OPEN_TO_WORK",
    HIRING = "HIRING",
}
export type RequestThresholds = {
    id: string;
    tooManyRequestCriticalThresholdPercentage: number;
    tooFewRequestCriticalThresholdPercentage: number;
    tooManyRequestWarningThresholdPercentage: number;
    tooFewRequestWarningThresholdPercentage: number;
};
export type RequestsThresholds = Array<RequestThresholds>;
